import { createContext } from "react";

export const ViloyatContext = createContext();
